export default "__VITE_ASSET__QttVw8oD__"